import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from './Navbar'

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar/>
      {/* Spacer for fixed navbar – pages other than HomePage use this to prevent content hiding under the nav */}
      <div className="h-[72px] flex-shrink-0" id="nav-spacer" />
      <Outlet />
    </div>
  )
}

export default Layout
